import { dateCalc } from '@mirai/locale';

import { MONTHS_IN_MOBILE } from '../../../../helpers';

export const getVisibleDate = (scrollPercentage, totalMonths = MONTHS_IN_MOBILE) => {
  if (scrollPercentage === undefined) return;

  const today = new Date();
  const percentagePerItem = 100 / (totalMonths - 1);
  const months = Math.floor(scrollPercentage / percentagePerItem);

  return months ? dateCalc(today, months, 'months') : today;
};
